<template>
	<div class='knd-loader' v-if="$store.state.loading">
		Laden
	</div>

	<div class='story' v-if="!$store.state.loading" >
		<Story 
			:content="$store.state.content"
			:overgewichtData="$store.state.overgewicht" 
		/>
	</div>
</template>

<script>
import Story from './components/story';

import './scss/index.scss';

export default {
	name: 'App',
	mounted: function() {
		this.$store.dispatch('loadData');
	},
	components: {
		Story,
	}
};
</script>